import BaseApi from '@core/api/model';

export class BrokerApi extends BaseApi {
    static resource = 'brokers';
}

export default BrokerApi;
